import { IconButton, Tooltip } from "@material-ui/core";
import { IconButtonProps } from "@material-ui/core/IconButton";
import { createStyles, CSSProperties, makeStyles } from "@material-ui/styles";
import classnames from "classnames";
import * as React from "react";

import { RelodeTheme } from "../";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            ...{
                root: {
                    padding: theme.spacing(1),
                    "& svg": {
                        alignSelf: "center",
                    },
                    marginRight: theme.spacing(1),
                },
                negative: {
                    //marginRight: theme.spacing(1),
                    color: theme.relode.colors.negativeAction.contrastText,
                    backgroundColor: theme.relode.colors.negativeAction.main, //
                    "&:hover": {
                        backgroundColor:
                            theme.relode.colors.negativeAction.dark, //
                    },
                },
                negativeDisabled: {
                    //marginRight: theme.spacing(1),
                    backgroundColor: theme.relode.colors.negativeAction.light,
                },
                positive: {
                    //marginRight: theme.spacing(1),
                    color: theme.relode.colors.positiveAction.contrastText,
                    backgroundColor: theme.relode.colors.positiveAction.main,
                    "&:hover": {
                        backgroundColor:
                            theme.relode.colors.positiveAction.dark,
                    },
                },
                positiveDisabled: {
                    //marginRight: theme.spacing(1),
                    backgroundColor: theme.relode.colors.positiveAction.light,
                },
                shadow: {
                    boxShadow: "0 4px 9px 0 rgba(0,0,0,0.1)",
                },
            },
            ...theme.relode.controls.pageActionButton,
        }),
    { name: "PageActionButton" }
);

type PageActionButtonCSSProperties =
    | "root"
    | "negative"
    | "negativeDisabled"
    | "positive"
    | "positiveDisabled";
export type PageActionButtonStyles = Partial<
    Record<
        PageActionButtonCSSProperties,
        CSSProperties | ((props?: {}) => CSSProperties)
    >
>;

interface InnerPageActionButtonProps {
    actionType?: "positive" | "negative";
    shadow?: boolean;
    dataCy?: string;
}

type PageActionButtonProps = InnerPageActionButtonProps & IconButtonProps;

export const PageActionButton = (props: PageActionButtonProps) => {
    const {
        id,
        title,
        disabled,
        className: classNameProp,
        color,
        children,
        actionType,
        shadow,
        dataCy,
        ...rest
    } = props;

    const classes = useStyles({});

    const rootClassNames = classnames(
        {
            [classes.root]: true,
            [classes.negative]:
                !!actionType && actionType === "negative" && !disabled,
            [classes.negativeDisabled]:
                !!actionType && actionType === "negative" && disabled,
            [classes.positive]:
                !!actionType && actionType === "positive" && !disabled,
            [classes.positiveDisabled]:
                !!actionType && actionType === "positive" && disabled,
            [classes.shadow]: shadow,
        },
        classNameProp
    );

    return (
        <Tooltip
            placement="bottom-start"
            title={(!disabled && title) || ""}
            disableFocusListener
        >
            <span data-cy={dataCy}>
                <IconButton
                    id={id}
                    disabled={disabled}
                    className={rootClassNames}
                    color={color}
                    {...rest}
                >
                    {children}
                </IconButton>
            </span>
        </Tooltip>
    );
};
